import { LoanTerms } from '../../common/types';
import { RentOrBuyState } from '../types';

export function setMonthlyRent(state: RentOrBuyState, payload: number): RentOrBuyState {
  return {
    ...state,
    monthlyRent: payload
  };
}

export function setExpectedAnnualRentIncrease(
  state: RentOrBuyState,
  payload: number
): RentOrBuyState {
  return {
    ...state,
    expectedAnnualRentIncrease: payload
  };
}

export function setHomePrice(state: RentOrBuyState, payload: number): RentOrBuyState {
  return {
    ...state,
    homePrice: payload,
    downPaymentPercent: (state.downPayment / payload) * 100
  };
}

export function setDownPayment(state: RentOrBuyState, payload: number): RentOrBuyState {
  return {
    ...state,
    downPayment: payload,
    downPaymentPercent: (payload / state.homePrice) * 100
  };
}
export function setDownPaymentPercent(state: RentOrBuyState, payload: number): RentOrBuyState {
  return {
    ...state,
    downPaymentPercent: payload,
    downPayment: state.homePrice * (payload / 100)
  };
}

export function setClosingCostPercent(state: RentOrBuyState, payload: number): RentOrBuyState {
  return {
    ...state,
    closingCostPercent: payload
  };
}

export function setInterestRate(state: RentOrBuyState, payload: number): RentOrBuyState {
  return {
    ...state,
    interestRate: payload
  };
}

export function setLoanTerm(state: RentOrBuyState, payload: LoanTerms): RentOrBuyState {
  return {
    ...state,
    loanTerm: payload
  };
}

export function setAnnualAppreciation(state: RentOrBuyState, payload: number): RentOrBuyState {
  return {
    ...state,
    annualAppreciation: payload
  };
}

export function setHowLongBeforeSelling(state: RentOrBuyState, payload: number): RentOrBuyState {
  return {
    ...state,
    howLongBeforeSelling: payload
  };
}

export function setCurrentAnnualInterest(state: RentOrBuyState, payload: number): RentOrBuyState {
  return {
    ...state,
    currentAnnualInterest: payload
  };
}

export function setIncomeTax(state: RentOrBuyState, payload: number): RentOrBuyState {
  return {
    ...state,
    incomeTax: payload
  };
}

export function setShowFull(state: RentOrBuyState, payload: boolean): RentOrBuyState {
  return {
    ...state,
    showFull: payload
  };
}

export function setDefaults(state: RentOrBuyState, initialState: RentOrBuyState): RentOrBuyState {
  return {
    ...initialState,
    showFull: true
  };
}
